import {
    GET_KINTONE,
    SETTING_KINTONE,
    CANCEL_KINTONE,
    SETTING_EMAIL,
    ADD_WORKSPACE,
    CANCEL_SETTING_EMAIL,
    WORKSPACE_STATUS,
    GET_SETTING_EMAIL,
    GET_WORKSPACE_KINTONE,
    DELETE_WORKSPACE,
    SETTING_PASSWORD_KINTONE
} from '@/api/modules/setting.api';

export default {
    getKintone({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_KINTONE(successCallback, errorCallback);
    },

    settingKintone({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        SETTING_KINTONE({ payload }, successCallback, errorCallback);
    },

    settingPasswordKintone({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        SETTING_PASSWORD_KINTONE({ payload }, successCallback, errorCallback);
    },

    cancelKintone({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        CANCEL_KINTONE({}, successCallback, errorCallback);
    },

    addWorkspace({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        ADD_WORKSPACE({ payload }, successCallback, errorCallback);
    },

    workspaceStatus({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        WORKSPACE_STATUS({ payload }, successCallback, errorCallback);
    },

    settingEmail({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        SETTING_EMAIL({ payload }, successCallback, errorCallback);
    },

    getSettingEmail({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_SETTING_EMAIL({ payload }, successCallback, errorCallback);
    },
    cancelSettingEmail({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        CANCEL_SETTING_EMAIL({ payload }, successCallback, errorCallback);
    },
    getListWorkspace({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_WORKSPACE_KINTONE({ payload }, successCallback, errorCallback);
    },

    deleteWorkspace({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        DELETE_WORKSPACE({ payload }, successCallback, errorCallback);
    }
};
